import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon, ZapIcon, ClockIcon } from 'lucide-react';
export function StartOnline() {
  return <section id="start-online" className="py-20 lg:py-28 bg-tlfc-stone" data-id="element-453">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-454">
        {/* Section Header */}
        <div className="reveal max-w-2xl" data-id="element-455">
          <span className="text-xs uppercase tracking-wider text-tlfc-blue font-medium" data-id="element-456">
            Digital Services
          </span>
          <h2 className="mt-4 font-serif text-3xl md:text-4xl text-tlfc-text" data-id="element-457">
            Start online, save time
          </h2>
          <p className="mt-3 text-tlfc-text-secondary text-lg" data-id="element-458">
            Get started immediately with our digital legal services.
          </p>
        </div>

        {/* Two Product Cards */}
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-459">
          {/* Family Law Online Card */}
          <div className="reveal bg-white border border-tlfc-border rounded-xl p-8 lg:p-10 shadow-soft card-hover hover:border-tlfc-gold/40" data-id="element-460">
            <div className="flex items-center gap-3" data-id="element-461">
              <div className="w-10 h-10 rounded-lg bg-tlfc-gold/10 flex items-center justify-center" data-id="element-462">
                <ZapIcon className="w-5 h-5 text-tlfc-gold" aria-hidden="true" data-id="element-463" />
              </div>
              <span className="text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-464">
                Family Law
              </span>
            </div>
            <h3 className="mt-5 font-serif text-2xl text-tlfc-text" data-id="element-465">
              Family Law Online
            </h3>
            <p className="mt-3 text-tlfc-text-secondary leading-relaxed" data-id="element-466">
              Start your family law matter online, then connect with a
              specialist. Get clarity on your situation before your first
              consultation.
            </p>
            <a href="#" className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-tlfc-gold text-white font-medium text-sm rounded-lg hover:bg-tlfc-gold-light transition-colors shadow-sm group" data-id="element-467">
              Start Family Law Online
              <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-468" />
            </a>
          </div>

          {/* Self Serve Portal Card */}
          <div className="reveal reveal-delay-1 bg-white border border-tlfc-border rounded-xl p-8 lg:p-10 shadow-soft card-hover hover:border-tlfc-blue/40" data-id="element-469">
            <div className="flex items-center gap-3" data-id="element-470">
              <div className="w-10 h-10 rounded-lg bg-tlfc-blue/10 flex items-center justify-center" data-id="element-471">
                <ClockIcon className="w-5 h-5 text-tlfc-blue" aria-hidden="true" data-id="element-472" />
              </div>
              <span className="text-xs uppercase tracking-wider text-tlfc-blue font-medium" data-id="element-473">
                24/7 Self Serve
              </span>
            </div>
            <h3 className="mt-5 font-serif text-2xl text-tlfc-text" data-id="element-474">
              Self Serve Portal
            </h3>
            <p className="mt-3 text-tlfc-text-secondary leading-relaxed" data-id="element-475">
              Fixed price legal documents drafted by our firm, available 24/7.
              Get what you need, when you need it.
            </p>

            {/* Document Links */}
            <div className="mt-6 space-y-3" data-id="element-476">
              <a href="#" className="flex items-center justify-between py-3 border-b border-tlfc-border text-sm text-tlfc-text-secondary hover:text-tlfc-text transition-colors group" data-id="element-477">
                <span data-id="element-478">Confidentiality Deed / NDA</span>
                <ArrowUpRightIcon className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" data-id="element-479" />
              </a>
              <a href="#" className="flex items-center justify-between py-3 border-b border-tlfc-border text-sm text-tlfc-text-secondary hover:text-tlfc-text transition-colors group" data-id="element-480">
                <span data-id="element-481">Company Power of Attorney</span>
                <ArrowUpRightIcon className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" data-id="element-482" />
              </a>
            </div>

            <a href="#" className="inline-flex items-center gap-2 mt-6 px-6 py-3 border border-tlfc-blue text-tlfc-blue font-medium text-sm rounded-lg hover:bg-tlfc-blue/5 transition-colors group" data-id="element-483">
              Open Self Serve Portal
              <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-484" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}